import { render } from "./contents.vue?vue&type=template&id=60390417"
const script = {}

import exportComponent from "/Users/yunusemresogut/Desktop/ishesap-partner/bayi_v2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__